import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { STHero } from '../components/skintyte/STHero';
import { STWhatIs } from '../components/skintyte/STWhatIs';
import { STHowItWorks } from '../components/skintyte/STHowItWorks';
import { STTreatmentAreas } from '../components/skintyte/STTreatmentAreas';
import { STCombine } from '../components/skintyte/STCombine';
import { STAddOns } from '../components/skintyte/STAddOns';
import { STFAQ } from '../components/skintyte/STFAQ';
import { STWhyChoose } from '../components/skintyte/STWhyChoose';
export function SkinTytePage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2632">
      <Navigation data-id="element-2633" />
      <main data-id="element-2634">
        <STHero data-id="element-2635" />
        <STWhatIs data-id="element-2636" />
        <STHowItWorks data-id="element-2637" />
        <STTreatmentAreas data-id="element-2638" />
        <STCombine data-id="element-2639" />
        <STAddOns data-id="element-2640" />
        <STFAQ data-id="element-2641" />
        <STWhyChoose data-id="element-2642" />
      </main>
      <Footer data-id="element-2643" />
    </div>;
}